import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ConfigProvider, theme } from "antd";
import { BrowserRouter } from "react-router-dom";
import StoreProvider from "./store/StoreProvider.tsx";
import AppRoute from "./shared/Route/AppRoute.tsx";
import "./index.css";
import { AppProvider } from "./shared/AppProvider/AppProvider.tsx";
import NetworkStatusNotifier from "./features/common/components/NetworkStatusNotifier.tsx";
import { WebsocketProvider } from "./shared/WebsocketContext/index.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <ConfigProvider
        theme={{
          algorithm: document.documentElement.classList.contains("dark")
            ? theme.darkAlgorithm
            : theme.defaultAlgorithm,
          token: {
            colorPrimary: "#1677ff", // customize your brand color
          },
        }}
      >
        <AppProvider>
          <StoreProvider>
            <WebsocketProvider>
              <BrowserRouter>
                <NetworkStatusNotifier />
                <AppRoute />
              </BrowserRouter>
            </WebsocketProvider>
          </StoreProvider>
        </AppProvider>
      </ConfigProvider>
    </GoogleOAuthProvider>
  </StrictMode>,
);
